/* eslint-disable @nx/enforce-module-boundaries */
import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TravelPricingService } from 'admin-drivers/src/app/api/services/travel-pricing.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TravelPricing } from 'admin-drivers/src/app/common/models/TravelPrincing';
import weekDays from '../../const/week-days';
import { VehicleTypesService } from 'admin-drivers/src/app/api/services/vehicle-types.service';
import { VehicleType } from 'admin-drivers/src/app/common/models/VehicleType';
import { tap } from 'rxjs';

@Component({
  selector: 't-llevo-travel-pricing-details',
  imports: [CommonModule, DatePipe],
  templateUrl: './travel-pricing-details.component.html',
  styleUrl: './travel-pricing-details.component.css',
})
export class TravelPricingDetailsComponent {
  private srv = inject(TravelPricingService);
  private vehicleSrv = inject(VehicleTypesService);
  protected images: string[] = [];
  protected data = toSignal<TravelPricing | null>(this.srv.item$);
  protected weekDaysList = weekDays;
  protected vehicleData = signal<VehicleType | null>(null);

  constructor() {
    this.srv.item$.subscribe((data) => {
      this.vehicleData.set(null);

      if (data) {
        this.vehicleSrv
          .getVehicleTypeById(data.typeVehicle)
          .pipe(tap((data) => this.vehicleData.set(data)))
          .subscribe();
      }
    });
  }

  protected hasOptionalData = computed(() => {
    if (
      this.data()?.costPerMinute ||
      this.data()?.pickupFee ||
      this.data()?.dropoffFee ||
      (this.data()?.surgeMultiplier ?? 0 > 1) ||
      this.data()?.minimumFare ||
      this.data()?.cancellationFee ||
      this.data()?.distanceThresholdKm
    ) {
      return true;
    }
    return false;
  });

  protected hasRuleData = computed(() => {
    if (
      this.data()?.rule?.geofence ||
      this.data()?.rule?.validTimeRange?.end ||
      this.data()?.rule?.validTimeRange?.start ||
      this.data()?.rule?.weekDay
    ) {
      return true;
    }
    return false;
  });
}
